import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { ExtratoContaUsuarioService } from './extrato-conta-usuario.service';
import { ModalDetalhesExtratoComponent } from './modal-detalhes-extrato/modal-detalhes-extrato.component';
import { NbDialogService } from '@nebular/theme';
import { ExportPdfService } from '../../../shared/services/export-pdf.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { CurrencyPipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-extrato-conta-usuario',
  templateUrl: './extrato-conta-usuario.component.html',
  styleUrls: ['./extrato-conta-usuario.component.scss'],
  providers: [CurrencyPipe]
})
export class ExtratoContaUsuarioComponent implements OnInit {

  @ViewChild('myTable', null)
  private myTable: DatatableComponent;

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public formExtratoContaOrbital = null;
  public extrato = null;
  public rowData = null;
  public columnsTabe = null;
  public tableLimit = 20;
  public listTipoConta = null;
  public cnpjCpf = null;
  public saldoConta = null;
  public customLogin = null;
  public listProduto = null;
  public listTipoTransacao = null;
  public disableIdentificador = true;
  public renderedSaldoConta = false;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
    monthLabels: {
      1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul',
      8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
    },
    firstDayOfWeek: 'su',
  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ExtratoContaUsuarioService,
    private dateUtilService: DateUtilService,
    private exportCsvService: ExportCsvService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService,
    private exportPdfService: ExportPdfService,
    private encriptyService: EncriptyUtilService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listTipoConta = [
      {
        tipoConta: 'TOP_PESSOA',
        descricao: 'TOP PESSOA',
      },
      {
        tipoConta: 'TOP_EMPRESA',
        descricao: 'TOP EMPRESA',
      },

    ];

    this.formExtratoContaOrbital = this.formBuilder.group({
      saldoConta: [null],
      dataInicio: [null],
      dataFim: [null],
      tipoConta: [null, Validators.required],
      identificador: [null, Validators.required],
      produto: null,
      tipoTransacao: [null],
    });

    this.listTipoTransacao = [
      { value: 'C', descricao: 'Entrada' },
      { value: 'D', descricao: 'Saída' }
    ];
  }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.saldoConta = 0;
    this.datatableService.subscribeTable(this.myTable);
  }

  abrirDetalhes(data: any) {

    var estabelecimento: string = '';

    if (data.tipoOperacao == 'CARD' || data.tipoOperacao == 'COMPRA' || data.tipoOperacao == 'SAQUE') {
      estabelecimento = data.estabelecimentoNome;
    }

    this.dialogService.open(ModalDetalhesExtratoComponent, {
      context: {
        dataAutorizacao: data.dataAutorizacao,
        descricao: data.label,
        valor: data.valor,
        valorTarifa: data.valorTarifa,
        estabelecimentoNome: estabelecimento,
      },
    });

  }

  async buscarExtrato(data?: any, page?: string | number) {

    if (this.validateParams(data)) {

      this.spinnerService.show();

      let params = this.getHttpParams(data);
      params = params.append('size', String(this.tableLimit));
      if (page !== null && page !== undefined && page !== '') {
        params = params.append('page', String(page));
      } else {
        await this.buscarSaldoConta(data);
      }

      this.service.buscaExtratoContaUsuario(params, (response => {

        if (Number(response.content.length) == 0) {
          this.paginationService.setInfo(response);
          this.spinnerService.hide();
          this.notificationService.warn('Não há dados nesse período');
          return;
        }

        response.content = response.content.map(item => {

          let valorNumerico = item.valor;
          if (item.sinal === '-') {
            valorNumerico = -parseFloat(item.valor);
          }
          const produtoDescricaoConvert = this.normalizeProdutoDescricao(
            item.descricaoProduto.replace(/_/g, ' ')
          );

          return {
            produto: produtoDescricaoConvert,
            data: item.dataLancamento,
            descricao: item.descricao,
            label: item.label,
            tipoTransacao: this.convertTipoTransacao(item.sinal),
            valor: valorNumerico,
          };
        });

        this.paginationService.setInfo(response);
        this.spinnerService.hide();

      }), (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      });

    }

  }

  async buscarSaldoConta(data?: any) : Promise<void> {
    this.renderedSaldoConta = false;

    let params = new HttpParams();
    if (data.tipoConta != null) {
      params = params.append('tipoConta', data.tipoConta);
    }
    if (data.identificador != null) {
      const idNorm = this.normalizarCnpjCpfParaBackend(data.identificador);
      if (idNorm !== '') {
        params = params.append('cpfCnpj', idNorm);
      }
    }
    const produto = data && data.produto;
    if (produto && !this.isEmpity(produto.produtoId)) {
      params = params.append('produtoId', produto.produtoId);
    }

    if (!produto || produto.produtoDescricao !== 'TODOS') {
      this.renderedSaldoConta = true;

      try {
        const response = await this.service.buscaSaldoContaUsuario(params);
        this.saldoConta = response.totalAmount;
      } catch (_error) {
        this.notificationService.error('Erro ao carregar o Saldo da Conta');
      }
    }
  }

  buscarProdutoAtivoCnpj(data) {

    if (data.tipoConta == null) {
      this.notificationService.error('O campo Tipo da Conta é obrigatório.');
      return;
    }

    const identificadorBruto = data.identificador;
    const idNorm = this.normalizarCnpjCpfParaBackend(identificadorBruto);
    const identificadorVazio =
      identificadorBruto == null ||
      String(identificadorBruto).trim() === '' ||
      idNorm === '';

    if (identificadorVazio) {
      this.listProduto = [];
      this.formExtratoContaOrbital.get('produto').patchValue(null);
      return;
    }

    this.spinnerService.show();

    const params = idNorm + '/' + data.tipoConta;

    this.service.buscarProdutoAtivoCnpj(params, (response) => {

      this.spinnerService.hide();

      if (response === null || response.length === 0) {
        this.listProduto = [];
        this.notificationService.warn('Não há produtos para o Identificador.');
        return;
      }

      this.listProduto = response.map(item => {
        const produtoDescricaoConvert = this.normalizeProdutoDescricao(
          item.produtoDescricao.replace(/_/g, ' ')
        );

        return {
          produtoDescricao: produtoDescricaoConvert,
          produtoId: item.produtoId
        };
      });

      if (this.listProduto.length > 1) {
        this.listProduto.unshift({ produtoDescricao: 'TODOS', produtoId: null });
      }

    }, (error) => {
      this.listProduto = [];
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  exportarExtrato(data?: any, tipo?: any) {

    if (this.validateParams(data)) {

      this.spinnerService.show();

      let params = this.getHttpParams(data);

      params = params.append('allElements', 'true');
      params = params.append('size', String(9999));

      this.service.buscaExtratoContaUsuario(params, (response => {

        if (Number(response.content.length) == 0) {
          this.spinnerService.hide();
          this.notificationService.warn('Não há dados para exportar.');
          return;
        }
        this.buscarSaldoConta(data);
        let totalSoma = 0;

        const dados = response.content.map(item => {

          let valorNumerico = item.valor;
          if (item.sinal === '-') {
            valorNumerico = -parseFloat(item.valor);
          }

          totalSoma = totalSoma + valorNumerico;

          const valorFormat = valorNumerico.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
          const dataFormat = this.dateUtilService.formatDate(new Date(item.dataLancamento), 'DD/MM/YYYY HH:mm');
          const produtoDescricaoConvert = this.normalizeProdutoDescricao(
            item.descricaoProduto.replace(/_/g, ' ')
          );

          return {
            produto: produtoDescricaoConvert,
            data: dataFormat,
            descricao: item.label,
            tipoTransacao: this.convertTipoTransacao(item.sinal),
            valor: valorFormat,
          };
        });

        if (String(tipo) == 'PDF') {
          const razaoSocial = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-name'));
          const cnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));
          const periodo = data.dataInicio.formatted + ' - ' + data.dataFim.formatted;

          let dataHeader = [
            { property: 'Relatório', value: 'Extrato', marginLeft: 5, marginTop: 35 },
            { property: 'Produto', value: this.normalizeProdutoDescricao(data.produto.produtoDescricao), marginLeft: 5, marginTop: 45 },
            { property: 'Cliente', value: razaoSocial, marginLeft: 5, marginTop: 50, style: {maxWidth: 120}},
            { property: 'CNPJ', value: cnpj, marginLeft: 120, marginTop: 45 },
            { property: 'Período', value: periodo, marginLeft: 120, marginTop: 50 },
            { property: 'Data e hora exportação', value: moment(new Date()).format('DD/MM/YYYY HH:mm:ss'), marginLeft: 140, marginTop: 35 },
          ];

          this.addSaldoDataHeader(data, dataHeader);

          const colunasPdf = [
            { title: 'Produto', dataKey: 'produto' },
            { title: 'Data', dataKey: 'data' },
            { title: 'Descrição', dataKey: 'descricao' },
            { title: 'Tipo', dataKey: 'tipoTransacao' },
            { title: 'Valor', dataKey: 'valor' },
          ];

          let dadosCustom = dados;
          dadosCustom.push(
            {
              produto: null,
              data: null,
              descricao: null,
              tipoTransacao: 'Total:',
              valor: totalSoma.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
            }
          );

          this.exportPdfService.exportPdf('ExtratoContaUsuario', colunasPdf, dadosCustom, dataHeader);
          this.spinnerService.hide();

        } else {
          const colunasCsv = [
            { columnName: 'produto', newColumnName: 'Produto' },
            { columnName: 'data', newColumnName: 'Data' },
            { columnName: 'descricao', newColumnName: 'Descrição' },
            { columnName: 'tipoTransacao', newColumnName: 'Tipo' },
            { columnName: 'valor', newColumnName: 'Valor' },
          ];

          this.exportCsvService.exportCsv(dados, colunasCsv, ',', 'ExtratoContaUsuario');
          this.spinnerService.hide();

        }

      }), (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      });
    }
  }

  getHttpParams(data) {
    let params = new HttpParams();

    if (!this.isEmpity(data.tipoConta)) {
      params = params.append('tipoConta', data.tipoConta);
    }
    if (data.identificador != null) {
      const idNorm = this.normalizarCnpjCpfParaBackend(data.identificador);
      if (idNorm !== '') {
        params = params.append('cpfCnpj', idNorm);
      }
    }
    if (data.dataInicio != null) {
      const dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio);
    }
    if (data.dataFim != null) {
      const dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim);
    }
    if (!this.isEmpity(data.tipoTransacao)) {
      params = params.append('tipoTransacao', data.tipoTransacao);
    }
    if (!this.isEmpity(data.produto.produtoId)) {
      params = params.append('produtoId', data.produto.produtoId);
    }
    return params;
  }

  validateParams(data) {
    if (this.isEmpity(data.tipoConta)) {
      this.notificationService.error('Campo Tipo da Conta é obrigatório!');
      return false;
    }
    if (data.identificador === null) {
      this.notificationService.error('Campo Identificador é obrigatório!');
      return false;
    }
    if (data.dataInicio === null) {
      this.notificationService.error('Campo Data Início é obrigatório!');
      return false;
    }
    if (data.dataFim === null) {
      this.notificationService.error('Campo Data Fim é obrigatório!');
      return false;
    }
    if (this.isEmpity(data.produto)) {
      this.notificationService.error('Campo Produto é obrigatório!');
      return false;
    }

    return true;
  }

  convertTipoTransacao(data) {
    if (data === '-') {
      return 'Saída(-)';
    } else {
      return 'Entrada(+)';
    }
  }

  getColorTipoTransacao(data) {
    if (data === 'Entrada(+)') {
      return '#008000';
    } else {
      return '#e91e1e';
    }
  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  isEmpity(data) {
    return data == null || data === 'null' || data === '' || data == undefined;
  }

  normalizeProdutoDescricao(produtoDescricao: string): string {
    if (this.isEmpity(produtoDescricao)) {
      return produtoDescricao;
    }
    if (produtoDescricao.toUpperCase() === 'SALARIO') {
      return 'PLATAFORMA PAGAMENTO';
    }
    return produtoDescricao;
  }


  habilitarIdentificador(event) {
    if (event != null && event !== 'null') {
      this.disableIdentificador = false;
    } else {
      this.disableIdentificador = true;
      this.formExtratoContaOrbital.get('identificador').patchValue(null);
    }
  }

  addSaldoDataHeader(data, dataHeader) {
    if (data.produto.produtoDescricao !== 'TODOS') {
      const saldoHeader: any = {
        property: 'Saldo', value: this.saldoConta.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
        , marginLeft: 175, marginTop: 55, style: { fontSize: 15, textAlignRight: true },
      };

      dataHeader.push(saldoHeader);
    }
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
